import { render } from "./CardSkeleton.vue?vue&type=template&id=1bcf6d18&scoped=true"
const script = {}

import "./CardSkeleton.vue?vue&type=style&index=0&id=1bcf6d18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcf6d18"]])

export default __exports__